module.exports = __webpack_public_path__ + "static/media/MM.00afa69c.png";